export default __webpack_public_path__ + "locales/en/OAuth.json?hash=3699e3dcfb965b07a11ec230874d319c";